<div>
  <div style="text-align: right; margin-bottom: 2%;">
    <button id="print-button" class="noPrint" style="margin-top: 2%; margin-right: 1%;"
      mat-raised-button color="primary"
      printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>

    <button (click)="print()" class="noPrint"
      style="display: none; margin-top: 2%; margin-right: 1%;"
      mat-raised-button color="primary">
      Print
    </button>

    <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
      Close
    </button>
  </div>

  <div class="container">
    <div id="print-section">
      <!-- Header -->
      <div style="text-align: center; font-weight: bold; font-size: xx-large; margin-bottom: 10px;">
        प्रतिनिधी प्रसिद्धी पत्रक
      </div>

      <div style="display: grid; grid-template-columns: repeat(4, 1fr); font-weight: bold; margin-bottom: 20px; white-space: nowrap;">
    
    <span style="text-align: left; padding-left: 15px;">
      अंक नाव :- {{ issuenamenew }}
    </span>

    <span style="text-align: center;">
      अंक दिनांक :- {{ issuedatepp | date : 'dd-MM-yyyy' }}
    </span>

    <span style="text-align: center;">
      प्रतिनिधी नाव :- {{ rep_name }}
    </span>

    <span style="text-align: right; padding-right: 15px;">
      दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}
    </span>

</div>


      <hr>

      <!-- Address Table -->
      <table style="width: 95%; margin: 0 auto; border-collapse: collapse; font-size: 18px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px; font-size: 20px;text-align: center;">प्रतिनिधी नाव</th>
            <th style="border: 1px solid #000; padding: 8px; font-size: 20px;text-align: center;">पत्ता</th>
            <th style="border: 1px solid #000; padding: 8px; font-size: 20px;text-align: center;">मो.क्र.</th>
            <th style="border: 1px solid #000; padding: 8px; font-size: 20px;text-align: center;">जाहिरात रक्क्म</th>
            <th style="border: 1px solid #000; padding: 8px; font-size: 20px;text-align: center;">जमा</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data2 of Address">
            <td style="border: 1px solid #000; padding: 8px;">
              <b>{{ data2.issueSellerName }}</b>
            </td>

            <td style="border: 1px solid #000; padding: 8px;">
              {{ data2.taluka }} ,{{ data2.district }}
            </td>

            <td style="border: 1px solid #000; padding: 8px; font-weight: bold;text-align: center;">
              {{ data2.mobile_no }}
            </td>
            <td style="border: 1px solid #000; padding: 8px; font-weight: bold;text-align: right;">
              {{ data2.invoice_amount }}
            </td>
            <td style="border: 1px solid #000; padding: 8px; font-weight: bold;text-align: right;">
              {{ data2.rcv_amt}}
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
